export default __webpack_public_path__ + "static/hero-84cd826f228d475084288ecc24caa55f.png";